import { render, staticRenderFns } from "./ListOfCancellations.vue?vue&type=template&id=48922076"
import script from "./ListOfCancellations.vue?vue&type=script&lang=js"
export * from "./ListOfCancellations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports